import { render } from "./CatDropdown.vue?vue&type=template&id=2d0f5c73&scoped=true"
import script from "./CatDropdown.vue?vue&type=script&lang=js"
export * from "./CatDropdown.vue?vue&type=script&lang=js"

import "./CatDropdown.vue?vue&type=style&index=0&id=2d0f5c73&lang=scss&scoped=true"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
script.render = render
script.__scopeId = "data-v-2d0f5c73"

export default script